import { Component } from 'preact';
import { renderRoutes } from 'react-router-config';
import { BrowserRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect, Provider } from 'react-redux';
import buildRoutes from '../routes';
import InitialDataRepository from '../repositories/InitialDataRepository';
import ScrollToTop from './ScrollToTop';
import ChatWithUs from './chat-with-us/ChatWithUs';

class AppRoot extends Component {

    /**
     * Note that fetch initial data is handled separately in server.js
     */
    componentDidMount() {
        this.props.fetchShopDetect();
        if (!this.props.initialized) {
            this.props.fetchInitialData();
        }
    }

    render = ({ store }) => (
        <Provider store={store}>
            <BrowserRouter>
                <div>
                    <ScrollToTop>
                        {renderRoutes(buildRoutes(store.getState()))}
                    </ScrollToTop>
                    <ChatWithUs />
                </div>
            </BrowserRouter>
        </Provider>
    );
}

const mapStateToProps = (state) => {
    const { ui } = state;

    return {
        initialized: ui.initialized
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchInitialData: InitialDataRepository.fetchInitialData,
    fetchShopDetect: InitialDataRepository.fetchShopDetect,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AppRoot);



// WEBPACK FOOTER //
// ./components/AppRoot.js